import type { HTMLAttributes, ReactNode } from 'react';

interface GlassCardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  elevated?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hoverable?: boolean;
}

/** @graph-connects none */
const PADDING_MAP = {
  none: '',
  sm: 'p-3',
  md: 'p-5',
  lg: 'p-6',
};

/**
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business グラスモーフィズムカードUI。elevated/padding/hoverableオプション付きの基盤コンテナ
 * @graph-connects none
 */
export function GlassCard({
  children,
  elevated = false,
  padding = 'md',
  hoverable = false,
  className = '',
  ...props
}: GlassCardProps) {
  return (
    <div
      className={`
        ${elevated ? 'glass-card-elevated' : 'glass-card'}
        ${PADDING_MAP[padding]}
        ${hoverable ? 'cursor-pointer' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
}
